(() => {
  if (window.OrtluxNavigation) {
    window.OrtluxNavigation.init();
    return;
  }
  let active, controller;
  const on = (target, event, handler, options = {}) =>
    target?.addEventListener(event, handler, {
      ...(typeof options === "boolean" ? { capture: options } : options),
      signal: controller.signal,
    });
  async function init() {
    const next = document.querySelector(".commerce-shell");
    if (!next || active === next) return;
    controller?.abort();
    active = next;
    controller = new AbortController();
    const instance = controller;
    await setup(instance);
  }
  async function setup(controller) {
    // Native details and real anchors provide the no-JavaScript navigation baseline.

    const reduced = matchMedia("(prefers-reduced-motion: reduce)");
    const items = [...document.querySelectorAll(".mega-item")];
    const locale = document.querySelector(".locale-picker");
    const browse = document.querySelector(".mobile-browse");
    const finePointer = matchMedia("(hover: hover) and (pointer: fine)");
    let hoverTimer;
    const animatePanel = (panel) => {
      if (!reduced.matches)
        panel.animate([{ transform: "translateY(-8px)" }, { transform: "none" }], {
          duration: 240,
          easing: "cubic-bezier(.22,1,.36,1)",
        });
    };
    const closeMenus = (except) => {
      [...items, locale, browse].forEach((item) => {
        if (item !== except) item.open = false;
      });
    };
    items.forEach((item) => {
      const summary = item.querySelector("summary");
      on(item, "toggle", () => {
        if (item.open) {
          closeMenus(item);
          animatePanel(item.querySelector(".mega-panel"));
        }
      });
      on(item, "pointerenter", () => {
        if (!finePointer.matches) return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(() => {
          closeMenus(item);
          item.open = true;
        }, 180);
      });
      on(item, "pointerleave", () => {
        clearTimeout(hoverTimer);
        if (finePointer.matches)
          hoverTimer = setTimeout(() => {
            if (!item.contains(document.activeElement)) item.open = false;
          }, 260);
      });
      on(summary, "keydown", (event) => {
        if (event.key === "ArrowDown") {
          event.preventDefault();
          closeMenus(item);
          item.open = true;
          item.querySelector(".mega-panel a").focus();
        }
      });
    });
    on(locale, "toggle", () => {
      if (locale.open) {
        closeMenus(locale);
        animatePanel(locale.querySelector(".locale-panel"));
      }
    });
    on(browse, "toggle", () => {
      if (browse.open) closeMenus(browse);
    });
    on(document, "keydown", (event) => {
      if (event.key !== "Escape") return;
      clearTimeout(hoverTimer);
      const active =
        [...items, locale, browse].find((el) => el.open && el.contains(document.activeElement)) ||
        [...items, locale, browse].find((el) => el.open);
      if (active) {
        active.open = false;
        active.querySelector("summary").focus();
      }
    });
    on(document, "pointerdown", (event) => {
      clearTimeout(hoverTimer);
      [...items, locale, browse].forEach((item) => {
        if (!item.contains(event.target)) item.open = false;
      });
    });
    on(document, "focusin", (event) => {
      items.forEach((item) => {
        if (!item.contains(event.target)) item.open = false;
      });
      if (!locale.contains(event.target)) locale.open = false;
    });
    on(matchMedia("(max-width:700px)"), "change", () => closeMenus());
    document.querySelectorAll('.commerce-shell a[href^="#"]').forEach((anchor) =>
      on(anchor, "click", () => {
        closeMenus();
        const target = document.getElementById(anchor.hash.slice(1));
        target?.setAttribute("tabindex", "-1");
        target?.focus({ preventScroll: true });
      }),
    );
    document.querySelectorAll(".site-search").forEach((form) => {
      const panel = form.querySelector(".search-panel");
      const input = form.querySelector("input");
      const trigger = form.querySelector('button[type="submit"]');
      const setState = (value) => {
        panel.hidden = !value;
        input.setAttribute("aria-expanded", String(value));
        trigger.setAttribute("aria-expanded", String(value));
        document.querySelectorAll(".compact-search-trigger").forEach((b) => {
          if (b.getAttribute("aria-controls") === panel.id) b.setAttribute("aria-expanded", String(value));
        });
      };
      on(form, "search:close", () => setState(false));
      on(form, "focusin", (e) => {
        if (e.target === input) {
          panel.querySelector(".search-status").textContent = "Enter a product or brand, then press Search.";
          setState(true);
        }
      });
      on(form.querySelector(".search-dismiss"), "click", () => {
        setState(false);
        input.focus();
      });
      on(form, "keydown", (e) => {
        if (e.key === "Escape") setState(false);
      });
    });
  }
  window.OrtluxNavigation = { init };
  document.addEventListener("shopify:section:load", (event) => {
    if (event.target.querySelector(".commerce-shell")) init();
  });
  document.addEventListener("shopify:section:unload", (event) => {
    if (active && event.target.contains(active)) {
      controller?.abort();
      active = null;
    }
  });
  init();
})();
